// extracted by mini-css-extract-plugin
module.exports = {"accordionTitle":"HowToUseAccordion_accordionTitle__0iLOm","productDescriptionBody":"HowToUseAccordion_productDescriptionBody__Mmc8U"};